import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SentenceCasePipe } from './pipes/sentence-case.pipe';

@NgModule({
  declarations: [SentenceCasePipe],
  exports: [SentenceCasePipe],
  imports: [CommonModule],
})
export class TextModule {}
